import type { LeadStatus } from '@embrace-returns/shared';
import { STATUS_LABEL } from '../status';

const STYLES: Record<LeadStatus, { pill: string; dot: string }> = {
  New: { pill: 'bg-emerald-50 text-emerald-700', dot: 'bg-emerald-500' },
  Closed: { pill: 'bg-gray-100 text-gray-500', dot: 'bg-gray-400' },
};

export function StatusBadge({ status }: { status: LeadStatus }) {
  const s = STYLES[status] ?? STYLES.Closed;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[12px] font-semibold ${s.pill}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
